import React from 'react';
import Client from './Client';
import PropTypes from 'prop-types';

export default function Clients({ clients }) {
    if (!clients.length) { return null; }

    return (
        <div className="list">
            <h3>{i18n.t('seller_profile.clients')}</h3>
            <ul>
                {clients.map((client, idx) =>
                    <Client client={client} key={idx}/>)}
            </ul>
        </div>
    );
}

Clients.propTypes = {
    clients: PropTypes.array
};

Clients.defaultProps = {
    clients: []
};



// WEBPACK FOOTER //
// ./src/common/InfoPanel/SellerProfile/Clients/index.js